"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonToReadable = void 0;
const formatPascalCase_1 = require("./formatPascalCase");
const jsonToReadable = (text) => {
    if (!text) {
        return "";
    }
    return text
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .split(" ")
        .map((val) => (0, formatPascalCase_1.pascalCase)(val))
        .join(" ");
};
exports.jsonToReadable = jsonToReadable;
